export default function() {
  var size = 0;
  this.each(function() { ++size; });
  return size;
}



//////////////////
// WEBPACK FOOTER
// /Users/danielcorrea/Documents/Workshops/d3Angulr/angular-d3-example/~/d3-selection/src/selection/size.js
// module id = ../../../../d3-selection/src/selection/size.js
// module chunks = 3